import { createStyles } from '@material-ui/core';
import { mainColor, UNIT } from '../../constants/theme';

export const styles = createStyles({
  detail: {
    marginTop: UNIT * 1.125
  },
  textStyle: {
    fontSize: UNIT * 1.125
  },
  progress: {
    margin: UNIT * 7.5
  },
  typoDetails: {
    fontSize: UNIT * 0.75,
    display: 'inline-block',
    width: '100%',
    color: mainColor.colorBlack
  },
  hrStyle: {
    border: '0',
    height: '1px',
    backgroundImage:
      'linear-gradient(to right, rgba(200, 200, 200, 0.5), rgba(200, 200, 200, 0.75), rgba(200, 200, 200, 0.5))'
  },
  subtitle: {
    fontWeight: 'bolder'
  },
  orderDetail: {
    color: mainColor.colorBlack,
    fontSize: UNIT * 0.875
  },
  labelStyle: {
    fontSize: UNIT * 0.75,
    color: mainColor.colorBlack,
    flexDirection: 'row',
    display: 'inline-block',
    width: '30%'
  },
  paperStyle: {
    padding: UNIT * 1.25,
    border: '1px solid #B5B3B3'
  },
  label: {
    color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
  },
  root: {
    width: '100%',
    '&$cssFocused $notchedOutline': {
      borderColor: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
    }
  },
  notchedOutline: {},
  cssFocused: {},
  heading: {
    fontSize: UNIT * 0.75,
    minWidth: UNIT * 3,
    fontWeight: 'bolder'
  },
  orderRow: {
    fontSize: UNIT * 0.6875,
    flexShrink: 0,
    minWidth: UNIT * 4.375,

    color: 'black !important'
  },
  checkboxRow: {
    fontSize: UNIT * 0.6875,
    flexShrink: 0,
    minWidth: 10,
    color: 'black !important'
  },
  arrow: {
    padding: '3px 0px 0px 0px'
  },
  margeDetail: {
    flexBasis: '4%',
    flexShrink: 0
  },
  table: {
    minWidth: 200,
    overflowX: 'auto'
  },
  iconStyle: {
    width: UNIT * 1.5,
    height: UNIT * 1.5,
    align: 'center',
    backgroundColor: 'transparent',
    color: mainColor.colorBlack
  },
  iconButton: {
    position: 'relative',
    right: '7px'
  },
  circularProgress: {
    textAlign: 'center',
    color: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 1)`
  },
  rowTitle: {
    flexdirection: 'row',
    justifyContent: 'flex-start',
    display: 'inline-block',
    margin: 10,
    width: '100%'
  },
  orderCol: { margin: '10px', minWidth: '200px' },
  content: {
    alignItems: 'center',
    width: '100%'
  },
  paper: {
    width: '100%'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  tableRow: {
    '&$selected, &$selected:hover': {
      backgroundColor: `rgba(${mainColor.red}, ${mainColor.green}, ${mainColor.blue}, 0.08)`
    }
  },
  selected: {},
  inputStyle: {
    display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: UNIT * 0.625
  }
});
